import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import { IGenericCatalog, INotification, IUserConfig, IUserInterviewers, IUserProfile } from 'src/interfaces';

export interface AuthState {
  validated: boolean;
  isLoggedIn: boolean;
  isClient: boolean;
  userInfo: any;
  roles: string[];
  userFullName: string;
  interviewers: IUserInterviewers[];

  userProfile: IUserProfile | null,
  profileRequest: IUserConfig | null;
  userCompany: IGenericCatalog | null,
  notificationsSendCount: number
  notifications: INotification[]

  //hasRole: any
}

const initialState: AuthState = {
  validated: false,
  isLoggedIn: false,
  isClient: true,
  userInfo: null,
  roles: [],
  userFullName: '',
  interviewers: [],
  userProfile: null,
  profileRequest: null,
  userCompany: null,
  notificationsSendCount: 0,
  notifications: []

  /*hasRole: (role) => {
    return this.roles.includes(role)
  }*/
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setIsLoggedIn(state, action: PayloadAction<boolean>) {
      state.isLoggedIn = action.payload;
    },

    setIsClient(state, action: PayloadAction<boolean>) {
      state.isClient = action.payload;
    },

    setUserFullName(state, action: PayloadAction<string>) {
      state.userFullName = action.payload;
    },

    setUserInfo(state, action: PayloadAction<string | null>) {
      state.userInfo = action.payload;
    },

    setIsValidated(state, action: PayloadAction<boolean>) {
      state.validated = action.payload;
    },

    setRoles(state, action: PayloadAction<[any]>) {
      let roles = action.payload;
      if (roles && roles.length > 0){
        state.roles = roles.map((role) => role.name)
      }
    },

    setInterviewers(state, action: PayloadAction<IUserInterviewers[]>) {
      state.interviewers = action.payload;
    },

    setUserProfile(state, action: PayloadAction<IUserProfile>) {
      state.userProfile = action.payload;
    },

    setProfileRequest(state, action: PayloadAction<IUserConfig>) {
      state.profileRequest = action.payload;
    },

    setUserCompany(state, action: PayloadAction<IGenericCatalog>) {
      state.userCompany = action.payload;
    },

    setNotifications(state, action: PayloadAction<INotification[]>) {
      state.notifications = action.payload;
    },

    setNotificationsSendCount(state, action: PayloadAction<number>) {
      state.notificationsSendCount = action.payload;
    },
  },
});

export const {
  setIsLoggedIn,
  setIsClient,
  setUserFullName,
  setUserInfo,
  setIsValidated,
  setRoles,
  setInterviewers,
  setUserProfile,
  setProfileRequest,
  setUserCompany,
  setNotifications,
  setNotificationsSendCount
} = authSlice.actions;

export default authSlice.reducer;
